(() => {
  'use strict';
  const q=(s,scope=document)=>scope.querySelector(s), qa=(s,scope=document)=>[...scope.querySelectorAll(s)];
  const root=(window.Shopify?.routes?.root || '/');
  let focusBeforeDrawer=null;
  let moneySettings={currency:window.Shopify?.currency?.active || 'USD',locale:document.documentElement.lang||'en'};
  try {const v=q('[data-mt-money]'); if(v) moneySettings=JSON.parse(v.textContent);} catch {}
  const money=cents=>new Intl.NumberFormat(moneySettings.locale,{style:'currency',currency:moneySettings.currency}).format(cents/100);
  const safeText=(el,t)=>{if(el) el.textContent=t;};
  const overlay=q('[data-mt-overlay]');
  // Native details must be open for desktop footer links to render in Chrome.
  const footerDesktop=window.matchMedia('(min-width: 750px)');
  const syncFooter=()=>qa('[data-mf-acc]').forEach(section=>section.open=footerDesktop.matches);
  syncFooter();
  footerDesktop.addEventListener('change',syncFooter);
  function closeDrawers(){
    qa('.mt-drawer,.mt-search-panel').forEach(el=>el.hidden=true);
    if(overlay) overlay.hidden=true;
    qa('[data-mt-open]').forEach(b=>b.setAttribute('aria-expanded','false'));
    document.body.classList.remove('mt-locked');
    focusBeforeDrawer?.focus?.();
  }
  async function openDrawer(name){
    closeDrawers(); focusBeforeDrawer=document.activeElement;
    const el=q(name==='cart'?'#mt-cart-drawer':name==='menu'?'#mt-menu':'#mt-search');
    if(!el)return;
    el.hidden=false; if(overlay)overlay.hidden=false;
    document.body.classList.add('mt-locked');
    qa(`[data-mt-open="${name}"]`).forEach(b=>b.setAttribute('aria-expanded','true'));
    (q('input',el)||q('button',el))?.focus();
    if(name==='cart') await renderCart();
  }
  qa('[data-mt-open]').forEach(b=>b.addEventListener('click',()=>openDrawer(b.dataset.mtOpen)));
  qa('[data-mt-close]').forEach(b=>b.addEventListener('click',closeDrawers));
  overlay?.addEventListener('click',closeDrawers);
  document.addEventListener('keydown',e=>{
    if(e.key==='Escape')closeDrawers();
    if(e.key==='Tab'){
      const active=q('.mt-drawer:not([hidden]),.mt-search-panel:not([hidden])');
      if(!active)return;
      const fields=qa('button:not([disabled]),a[href],input,select,summary',active).filter(el=>el.offsetParent!==null);
      const first=fields[0],last=fields.at(-1);
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}
      if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
    }
  });
  q('[data-mt-country]')?.addEventListener('change',e=>e.target.form.submit());
  const messages=qa('.mt-announcement-message>span'); let messageIdx=0;
  if(messages.length){messages.forEach((el,i)=>el.hidden=!!i);setInterval(()=>{messages[messageIdx].hidden=true;messageIdx=(messageIdx+1)%messages.length;messages[messageIdx].hidden=false;},4500);}
  // Original homepage collection tabs, connected to destination collection products.
  qa('[data-collection]').forEach(button=>button.addEventListener('click',()=>{
    const wrap=button.closest('[data-mt-collection-tabs]');
    if(!wrap)return;
    qa('[data-collection]',wrap).forEach(b=>b.classList.toggle('active',b===button));
    qa('[data-collection-content]',wrap).forEach(p=>p.classList.toggle('active',p.dataset.collectionContent===button.dataset.collection));
  }));
  qa('[class*="mf__toggle"]').forEach(b=>b.addEventListener('click',()=>{
    const value=b.getAttribute('aria-expanded')!=='true';b.setAttribute('aria-expanded',String(value));
    const id=b.getAttribute('aria-controls');if(id){const el=document.getElementById(id);if(el)el.hidden=!value;}
    b.parentElement.classList.toggle('is-open',value);
  }));
  qa('button[class*="fq__q"],button[class*="faq-question"]').forEach(b=>{
    b.addEventListener('click',()=>{
      const value=b.getAttribute('aria-expanded')!=='true';b.setAttribute('aria-expanded',String(value));
      const id=b.getAttribute('aria-controls'); const panel=id?document.getElementById(id):b.nextElementSibling;
      if(panel){panel.hidden=!value;panel.style.maxHeight=value?panel.scrollHeight+'px':'';}
      b.closest('[class*="fq__item"]')?.classList.toggle('is-open',value);
    });
  });
  q('[data-mt-sort]')?.addEventListener('change',e=>{const u=new URL(location.href);u.searchParams.set('sort_by',e.target.value);u.searchParams.delete('page');location.href=u;});
  async function renderCart(){
    const body=q('[data-mt-cart-body]');if(!body)return;
    try{
      const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
      if(!response.ok)throw Error('Unable to load your cart.');
      const cart=await response.json(); body.replaceChildren();
      qa('[data-mt-cart-count]').forEach(el=>{el.textContent=cart.item_count;el.hidden=cart.item_count===0;});
      q('[data-mt-cart-footer]').hidden=cart.item_count===0;
      if(!cart.items.length){
        const p=document.createElement('p');p.textContent='Your cart is empty.';
        const a=document.createElement('a');a.href=root+'collections/all';a.className='mt-black-button';a.textContent='Continue shopping';body.append(p,a);return;
      }
      cart.items.forEach(item=>{
        const line=document.createElement('div');line.className='mt-cart-line';
        const img=document.createElement('img');img.src=item.image||'';img.alt=item.product_title;img.width=110;img.height=140;
        const content=document.createElement('div');const a=document.createElement('a');a.href=item.url;a.textContent=item.product_title;
        const variant=document.createElement('p');variant.textContent=item.variant_title==='Default Title'?'':item.variant_title;
        const price=document.createElement('p');price.textContent=money(item.final_line_price);
        const controls=document.createElement('div');controls.className='mt-cart-controls';
        for(const [label,qty]of [['−',item.quantity-1],[String(item.quantity),null],['+',item.quantity+1]]){
          const el=document.createElement(qty===null?'span':'button');el.textContent=label;
          if(qty!==null){el.type='button';el.setAttribute('aria-label',(qty>item.quantity?'Increase':'Decrease')+' quantity for '+item.product_title);el.addEventListener('click',()=>changeCart(item.key,qty));}
          controls.append(el);
        }
        const remove=document.createElement('button');remove.type='button';remove.className='mt-remove';remove.textContent='Remove';remove.addEventListener('click',()=>changeCart(item.key,0));
        content.append(a,variant,price,controls,remove);line.append(img,content);body.append(line);
      });
      safeText(q('[data-mt-cart-total]'),money(cart.total_price));
    }catch(error){safeText(body,error.message);}
  }
  async function changeCart(id,quantity){
    const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id,quantity})});
    if(!response.ok){const error=await response.json();alert(error.description||'Unable to update quantity.');return;}
    await renderCart();
  }
  let searchTimer;const searchInput=q('#mt-search input[name="q"]');
  searchInput?.addEventListener('input',()=>{
    clearTimeout(searchTimer);
    searchTimer=setTimeout(async()=>{
      const box=q('[data-mt-search-results]'), term=searchInput.value.trim();box.replaceChildren();if(term.length<2)return;
      try{
        const params=new URLSearchParams({q:term,'resources[type]':'product','resources[limit]':'6'});
        const response=await fetch(root+'search/suggest.json?'+params);if(!response.ok)return;
        const json=await response.json();if(searchInput.value.trim()!==term)return;
        for(const item of json.resources?.results?.products||[]){const a=document.createElement('a');a.href=item.url;const img=document.createElement('img');img.src=item.image;img.alt=item.title;const text=document.createElement('span');text.textContent=item.title;a.append(img,text);box.append(a);}
      }catch{}
    },250);
  });
  const productRoot=q('[data-mt-product]');if(!productRoot)return;
  let product;try{product=JSON.parse(q('[data-mt-product-json]',productRoot).textContent);}catch{return;}
  const slides=qa('[data-pg-slide]',productRoot), thumbs=qa('[data-mt-gallery-thumb]',productRoot);let slideIndex=0;
  function showSlide(index){
    if(!slides.length)return;slideIndex=(index+slides.length)%slides.length;
    slides.forEach((s,i)=>s.classList.toggle('is-active',i===slideIndex));thumbs.forEach((t,i)=>{t.classList.toggle('is-active',i===slideIndex);t.setAttribute('aria-current',String(i===slideIndex));});
    const ratio=Number(slides[slideIndex].dataset.ratio);if(ratio>0)q('[data-pg-slides]',productRoot).style.aspectRatio=String(ratio);
    safeText(q('[data-mt-gallery-count]'),`${slideIndex+1} / ${slides.length}`);
  }
  thumbs.forEach(b=>b.addEventListener('click',()=>showSlide(+b.dataset.mtGalleryThumb)));
  q('[data-mt-gallery-prev]')?.addEventListener('click',()=>showSlide(slideIndex-1));q('[data-mt-gallery-next]')?.addEventListener('click',()=>showSlide(slideIndex+1));
  let touchStart; q('[data-pg-slides]')?.addEventListener('touchstart',e=>touchStart=e.changedTouches[0].clientX,{passive:true});q('[data-pg-slides]')?.addEventListener('touchend',e=>{const distance=e.changedTouches[0].clientX-touchStart;if(Math.abs(distance)>45)showSlide(slideIndex+(distance<0?1:-1));},{passive:true});
  slides.forEach(s=>s.addEventListener('click',()=>{const dialog=q('#mt-image-zoom');q('img',dialog).src=q('img',s).currentSrc;q('img',dialog).alt=q('img',s).alt;dialog.showModal();}));
  q('[data-mt-close-zoom]')?.addEventListener('click',()=>q('#mt-image-zoom').close());
  const optionButtons=qa('[data-mt-option]',productRoot);
  let selected=qa('[data-vx-group]',productRoot).map(g=>q('.is-on',g)?.dataset.value);
  const selectedId=q('[data-mt-variant-id]',productRoot);
  function updateVariant(){
    const variant=product.variants.find(v=>v.options.every((value,i)=>value===selected[i]));
    const button=q('[data-mt-add]'); selectedId.value=variant?.id||'';
    button.disabled=!variant?.available; safeText(q('span',button),!variant?'UNAVAILABLE':variant.available?'ADD TO CART':'SOLD OUT');
    optionButtons.forEach(b=>{const active=selected[+b.dataset.optionIndex]===b.dataset.value;b.classList.toggle('is-on',active);b.setAttribute('aria-pressed',String(active));});
    qa('[data-vx-group]',productRoot).forEach((g,i)=>safeText(q('[data-vx-current]',g),selected[i]));
    if(!variant)return;
    safeText(q('[data-mt-price]'),money(variant.price));const compare=q('[data-mt-compare]'),badge=q('[data-mt-saving]');const onSale=variant.compare_at_price>variant.price;
    q('[data-mt-price]').classList.toggle('is-sale',onSale);
    compare.hidden=!onSale;badge.hidden=!onSale;safeText(compare,money(variant.compare_at_price||0));safeText(badge,onSale?'−'+Math.round((1-variant.price/variant.compare_at_price)*100)+'%':'');
    const u=new URL(location.href);u.searchParams.set('variant',variant.id);history.replaceState({},'',u);
    const mediaId=variant.featured_image?.id||variant.featured_media?.id;const index=slides.findIndex(s=>s.dataset.mediaId==mediaId);if(index>=0)showSlide(index);
    q('.mt-stock-note')?.setAttribute('hidden','');
  }
  optionButtons.forEach(b=>b.addEventListener('click',()=>{selected[+b.dataset.optionIndex]=b.dataset.value;updateVariant();}));
  const form=q('#MTProductForm');form?.addEventListener('submit',async e=>{
    e.preventDefault();const error=q('[data-mt-add-error]'),button=q('[data-mt-add]');error.hidden=true;button.disabled=true;safeText(q('span',button),'ADDING…');
    try{
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});const result=await response.json();
      if(!response.ok)throw Error(result.description||'Unable to add this item. Please choose an available option.');
      await openDrawer('cart');
    }catch(ex){error.hidden=false;error.textContent=ex.message;}
    finally{const variant=product.variants.find(v=>String(v.id)===selectedId.value);button.disabled=!variant?.available;safeText(q('span',button),variant?.available?'ADD TO CART':'SOLD OUT');}
  });
  q('[data-mt-size-guide]')?.addEventListener('click',()=>{
    const dialog=q('#mt-size-guide'), content=q('[data-mt-guide-content]');content.replaceChildren();
    const description=q('[data-mt-description]');const table=q('table',description);const sizeImages=qa('img',description).filter(i=>/size|chart|measurement/i.test(i.alt+' '+i.src));
    if(table)content.append(table.cloneNode(true));else if(sizeImages.length)sizeImages.forEach(i=>content.append(i.cloneNode(true)));else{const p=document.createElement('p');const sizes=product.options.find(o=>/size/i.test(typeof o==='string'?o:o.name));const idx=product.options.indexOf(sizes);const values=[...new Set(product.variants.map(v=>v.options[idx]).filter(Boolean))];p.textContent='Available sizes: '+values.join(', ')+'. Refer to the product description for fit and material details. If you need exact measurements, our team can help before you order.';content.append(p);}dialog.showModal();
  });
  q('[data-mt-close-guide]')?.addEventListener('click',()=>q('#mt-size-guide').close());
})();
